import { DataGrid } from "devextreme-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  actionSummaryCdBalList,
  actionSummaryRenewalList,
  actionSummaryClaimStatusList,
  actionSummaryQuoteStatusList,
  resetSummaryCdBalList,
  resetSummaryRenewalList,
  resetSummaryClaimStatusList,
  resetSummaryQuoteStatusList,
} from "../store";
import { useDispatch, useSelector } from "react-redux";
import Chart from "react-apexcharts";
import Loader from "../../../../../component/page_loader";
import toast from 'react-hot-toast';
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../../common/app_constant";
import { getLocalStorageItem } from "../../../../../utils";

const EmployerDashboard = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const navigate = useNavigate();
  const item = localStorage.getItem("next")
  console.log("fsdfsd", item)

  const [summaryRenewalListOptions, setSummaryRenewalListOptions] = useState([]);
  const [summaryCdBalListOptions, setSummaryCdBalListOptions] = useState([]);
  const [summaryClaimStatusListOption, setSummaryClaimStatusListOption] = useState([]);
  const [summaryQuoteStatusListOption, setSummaryQuoteStatusListOption] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const [role, setRole] = useState();

  const { SummaryRenewalList } = useSelector(state => ({
    ...state.employerStore,
  }));

  const { SummaryCdBalList } = useSelector(state => ({
    ...state.employerStore,
  }));

  const { SummaryClaimStatusList } = useSelector(state => ({
    ...state.employerStore,
  }));

  const { SummaryQuoteStatusList } = useSelector(state => ({
    ...state.employerStore,
  }));



  // api call
  useEffect(() => {
    dispatch(actionSummaryRenewalList());
    dispatch(actionSummaryCdBalList());
    dispatch(actionSummaryClaimStatusList());
    dispatch(actionSummaryQuoteStatusList());
    setRole(getLocalStorageItem("next"));
  }, []);


  // to store data for renewal 
  useEffect(() => {
    dispatch(resetSummaryRenewalList());
    if (SummaryRenewalList != null) {
      if (SummaryRenewalList.status == true) {
        setIsLoader(false);
        setSummaryRenewalListOptions(SummaryRenewalList.data);
      } else {
        setIsLoader(false);
        switch (SummaryRenewalList.status_code) {
          case 400:
            toast.error(SummaryRenewalList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [SummaryRenewalList]);

  // to store data for Cd bal
  useEffect(() => {
    dispatch(resetSummaryCdBalList());
    if (SummaryCdBalList != null) {
      if (SummaryCdBalList.status == true) {
        setIsLoader(false);
        setSummaryCdBalListOptions(SummaryCdBalList.data);
      } else {
        setIsLoader(false);
        switch (SummaryCdBalList.status_code) {
          case 400:
            toast.error(SummaryCdBalList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [SummaryCdBalList]);

  // to store data for claim status

  // to store data for quote status



  useEffect(() => {
    const hasReloadedEmployer = localStorage.getItem("hasReloadedEmployer");
    if (!hasReloadedEmployer) {
      localStorage.setItem("hasReloadedEmployer", true);
      window.location.reload();
    }
  }, []);

  return (
    <>
      <div className="container-fluid mb-5 mt-6">
        <h5>Dashboard</h5>
        {isLoader === true ? (
          <Loader />
        ) : (
          <>
            <div className="row mt-3">
              <div className="col-12 col-md-6 ">
                <div className="card h-100">
                  <div className="card-header bg-white">
                    <h6 className="mb-0 text-primary">Renewal Status</h6>
                  </div>
                  <div className="card-body">
                    <ol class="list-group list-unstyled">
                      {summaryRenewalListOptions ?
                        summaryRenewalListOptions?.map(
                          (item, { label, colour, value }, index) => (
                            <li
                              onClick={() => {
                                navigation("/employer/policies", {
                                  state: { data: item },
                                });
                              }}
                              key={index}
                              className={`list-group-item d-flex justify-content-between align-items-start border-0 cursor-pointer ${item.colour}`}
                            >
                              <div className="me-auto my-auto">
                                <div>{item.label}</div>
                              </div>
                              <span>{item.value}</span>
                            </li>
                          )
                        )
                      :
                      <>
                      <div className="text-center">
                        <h6>No Data to Display</h6>
                        </div>
                      </>}
                    </ol>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 ">
                <div className="card">
                  <div className="card-header bg-white">
                    <h6 className="mb-0 text-primary">CD Balance Summary</h6>
                  </div>
                  <div className="card-body">
                    <ol class="list-group list-unstyled">
                      {summaryCdBalListOptions &&
                        summaryCdBalListOptions?.map(
                          (item, { label, colorcode, value }, index) => (
                            <li
                              onClick={() => {
                                // condition 1
                                if (item.label === "Quotes due days <= 10 days" || item.label === "Quotes due days 1l ‹ and <= 20 days" || item.label === "Quotes due days 21 < and <= 30 days" || item.label === "Quotes due days 31 < and <= 60 days" || item.label === "New Vehicle Quotes") {
                                  navigation("/employer/quotes", {
                                    state: { data: item },
                                  });
                                }
                                else if(item.label ==='Pending Recovery'){
                                  navigation("/employer/task-panel", {
                                    state: { data: item },
                                  });
                                }
                                else {
                                  navigation("/employer/cd-balance", {
                                    state: { data: item },
                                  });
                                }
                              }}

                              key={index}
                              className={`list-group-item d-flex justify-content-between align-items-start border-0 cursor-pointer ${item.colour}`}
                            >
                              <div class="me-auto">
                                <div>{item.label}</div>
                              </div>
                              <span className="cursor-pointer">
                                {
                                 role == "employerdashboard" && (item.label ==='Current Balance' || item.label==='Effective Net Balance') ? 
                                  'XXXXXXXX'
                                  :
                                  item.value ? Number(item.value)?.toFixed(2) : "-"
                                }
                              </span>
                            </li>
                          )
                        )}
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EmployerDashboard;
